const PerformanceDateRange = Object.freeze({
  LAST_1_DAY: '1d',
  LAST_7_DAYS: '7d',
  LAST_30_DAYS: '30d',
  LAST_90_DAYS: '90d',
});

export default PerformanceDateRange;
